import '../ezhard-root/tokens/tokens.css';
import '@ezhard/ui/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/app/App';
import { registerSW } from 'virtual:pwa-register';

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  registerSW({ immediate: true });
}
/**
 * EZShift — Entry Point
 *
 * Renders the root App component into the DOM.
 * App provides: BrowserRouter, DataProvider, i18n, Suspense, and AppShell layout.
 */

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
